const _ = 2, A = 1, E = 120;
export {
  _ as DEFAULT_BATCH_SIZE,
  A as DEFAULT_MAX_YEARS,
  E as SCROLL_TOP_BUFFER
};
